import PropTypes from 'prop-types';
import { themePropType } from './sharedPropTypes';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import '../App.css';
const Pill = React.memo(({ theme, title, children, windowStyle={} }) => {//children used for content sections and windowStyle used for custom style overrides
    const pillDay = require('../static/images/assetComponents/pill/day.png');
    const pillNight = require('../static/images/assetComponents/pill/night.png');
    const nodeRef = useRef(null); //ref for draggable component
    
    return(
        <div
        ref={nodeRef} 
        className='pill-container'
        style={{
          backgroundImage:`url(${theme === 'light' ? pillDay : pillNight})`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
        }}
        >
            <span className="pill-content">{title}</span>
        </div>
    );
});
Pill.propTypes = {
  theme: themePropType, //Using shared prop type
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  windowStyle: PropTypes.object
};

export default Pill;